module.exports = __webpack_public_path__ + "static/media/icono_panificacion_am.15b88d57.png";